import elementTypes from '../../elements/types';
import HelptapEditor from '../';
import * as baseNodeUtilities from './base-node';

export function getDefaultOptions() {

  const options = baseNodeUtilities.getDefaultOptions();

  return options;

}

export function buildNode(options = {}) {

  const node = {
    ...getDefaultOptions(),
    ...options,
    type: elementTypes.DIVIDER
  };

  return node;

}

export function insert(editor, path) {

  HelptapEditor.insertParagraph(editor, {}, path);

}

export function toggle(editor) {

  const nodeOptions = buildNode();

  HelptapEditor.setNodeOptions(editor, nodeOptions);

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = HelptapEditor.cloneNode(node);

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}